import React from "react";
import { Text } from "../components";
import { ReactComponent as WorldIcon } from "../assets/icons/world.svg";
import { ReactComponent as PinIcon } from "../assets/icons/pin.svg";
import { ReactComponent as CallIcon } from "../assets/icons/call.svg";

export const getContactsList = (contacts?: string) => {
  switch (contacts) {
    case "pad":
      return pad;
    case "padViolencesFamiliales":
      return padViolencesFamiliales;
    case "padDiscri":
      return padDriscri;
    case "padCresus":
      return padCresus;
    case "padConciliateurJustice":
      return padConciliateurJustice;
    case "padMediateurVoyage":
      return padMediateurVoyage;
    case "padMediateurAssurance":
      return padMediateurAssurance;
    case "padAdil":
      return padAdil;
    case "padAdilConciliation":
      return padAdilConciliation;
    case "padMediateurCommunication":
      return padMediateurCommunication;
    case "padPlainte":
      return padPlainte;
    case "padSncf":
      return padSncf;
    case "padOperateur":
      return padOperateur;
    case "padTransport":
      return padTransport;
    case "padProc":
      return padProc;
    case "padCnil":
      return padCnil;
    default:
      return pad;
  }
};

const justicePoints = {
  icon: <PinIcon />,
  title: "Annuaire des point-justice",
  description: (
    <Text>
      Vous pouvez aller dans le point de justice le plus proche de chez vous
      pour rencontrer des professionnels du droit et des associations
      gratuitement :{" "}
      <a
        href="http://www.annuaires.justice.gouv.fr/annuaires-12162/les-point-justice-34055.html"
        target="_blank"
        rel="noreferrer"
      >
        Trouver votre point-justice
      </a>
    </Text>
  ),
};

const justiceAppel = {
  icon: <CallIcon />,
  title: "Centre d'appel point-justice",
  description: (
    <Text>
      Pour contacter un point-justice, appelez gratuitement le numéro{" "}
      <a href="tel:3039" target="_blank" rel="noreferrer">
        {" "}
        3039
      </a>{" "}
      depuis la France métropolitaine ou le{" "}
      <a href="tel:0970823190" target="_blank" rel="noreferrer">
        {" "}
        09 70 82 31 90
      </a>{" "}
      depuis les collectivités d'outre-mer et l'étranger.
    </Text>
  ),
};

export const pad = [
  {
    icon: <WorldIcon />,
    title: "Site Service Public",
    description: (
      <Text>
        Vous pouvez aller sur le site{" "}
        <a
          href="https://www.service-public.fr"
          target="_blank"
          rel="noreferrer"
        >
          Service public
        </a>{" "}
        pour avoir des informations sur votre situation et les démarches à
        faire.
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];

export const padProc = [
  {
    icon: <WorldIcon />,
    title: "Démarche après une plainte classée sans suite",
    description: (
      <Text>
        Il est possible de contester le classement sans suite par courrier
        adressé au procureur général de la cour d'appel. Le courrier peut être
        envoyé en lettre simple ou par lettre recommandée avec accusé de
        réception :{" "}
        <a
          href=" http://www.annuaires.justice.gouv.fr/annuaires-12162/annuaire-des-cours-dappel-21767.html"
          target="_blank"
          rel="noreferrer"
        >
          Coordonnées cours d'appel
        </a>{" "}
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];

export const padViolencesFamiliales = [
  {
    icon: <WorldIcon />,
    title: "Associations victimes de violences conjugales et/ou familiales",
    description: (
      <Text>
        Si vous êtes victime de violences conjugales et/ou familiales, voici une
        liste d'associations en mesure de vous écouter et de vous aider :{" "}
        <a
          href="https://maisondesliensfamiliaux.fr/categorie/victimes-de-violences-conjugales-et-ou-familiales/"
          target="_blank"
          rel="noreferrer"
        >
          Lien associations
        </a>
      </Text>
    ),
  },
  justicePoints,
  {
    icon: <CallIcon />,
    title: "Numéro Enfance en danger",
    description: (
      <Text>
        Si vous êtes victime ou si vous avez connaissance d'une situation de
        maltraitance d'un enfant, vous devez appeler le{" "}
        <a href="tel:119" target="_blank" rel="noreferrer">
          {" "}
          119
        </a>{" "}
      </Text>
    ),
  },
];
export const padDriscri = [
  {
    icon: <WorldIcon />,
    title: "Plateforme antidiscriminations",
    description: (
      <Text>
        Le Défenseur des droits peut vous accompagner ou vous orienter
        gratuitement en cas de violences et de propos haineux :{" "}
        <a
          href="https://www.antidiscriminations.fr/"
          target="_blank"
          rel="noreferrer"
        >
          Plateforme antidiscriminations
        </a>
      </Text>
    ),
  },
  justicePoints,
  {
    icon: <CallIcon />,
    title: "Téléphone plateforme antidiscriminations",
    description: (
      <Text>
        Les équipes du Défenseur des droits vous répondent directement et
        gratuitement pour vous accompagner selon votre situation au{" "}
        <a href="tel:3928" target="_blank" rel="noreferrer">
          {" "}
          3928
        </a>{" "}
        . Les échanges sont confidentiels.
      </Text>
    ),
  },
];
export const padCresus = [
  {
    icon: <WorldIcon />,
    title: "Association CRESUS",
    description: (
      <Text>
        Besoin d'aide pour votre dossier de surendettement ? Trouvez
        l'association CRESUS proche de chez vous pour répondre à vos questions :{" "}
        <a href="https://www.cresus.org/" target="_blank" rel="noreferrer">
          Lien association CRESUS
        </a>
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padConciliateurJustice = [
  {
    icon: <WorldIcon />,
    title: "Faire appel à un conciliateur de justice",
    description: (
      <Text>
        Le conciliateur de justice est un professionnel de justice bénévole. Son
        rôle est de trouver une solution amiable à un désaccord entre une ou
        plusieurs personnes, qu'elles aient ou non déjà saisi un juge. Le
        conciliateur de justice vous aide gratuitement.{" "}
        <a
          href="https://www.service-public.fr/particuliers/vosdroits/F1736"
          target="_blank"
          rel="noreferrer"
        >
          Procédure conciliateur de justice
        </a>
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padMediateurVoyage = [
  {
    icon: <WorldIcon />,
    title: "Faire appel au Médiateur du tourisme et du voyage",
    description: (
      <Text>
        Vous devez prendre contact avec le service client de réservation de
        votre billet d'avion. Si vous n'avez pas eu de réponse dans les deux
        mois ou si vous avez eu une réponse négative, vous pouvez{" "}
        <a
          href="https://www.service-public.fr/particuliers/vosdroits/R46367"
          target="_blank"
          rel="noreferrer"
        >
          faire appel au médiateur tourisme et voyage
        </a>
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padMediateurAssurance = [
  {
    icon: <WorldIcon />,
    title: "Faire appel au Médiateur de l'assurance",
    description: (
      <Text>
        Vous avez un désaccord avec votre assureur ? <br />
        Si vous avez du mal à régler ce désaccord, vous pouvez saisir{" "}
        <a
          href="https://www.service-public.fr/particuliers/vosdroits/R12259"
          target="_blank"
          rel="noreferrer"
        >
          Le médiateur de l'assurance
        </a>
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padAdil = [
  {
    icon: <WorldIcon />,
    title:
      "Rencontrer un juriste de l'ADIL (Agence Départementale d'Information sur le Logement)",
    description: (
      <Text>
        Les ADIL informent gratuitement les usagers sur leurs droits et leurs
        obligations et sur les solutions de logement adaptées à leurs besoins.
        Vous pouvez trouver{" "}
        <a
          href="https://www.anil.org/lanil-et-les-adil/votre-adil/"
          target="_blank"
          rel="noreferrer"
        >
          trouver l'ADIL la plus proche de chez vous
        </a>
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padAdilConciliation = [
  {
    icon: <WorldIcon />,
    title: "Faire appel à la commission départementale de conciliation (CDC)",
    description: (
      <Text>
        La commission départementale de conciliation (CDC) aide propriétaire
        (bailleur) et locataire à trouver une solution amiable à leur litige.
        Selon le type de litige (état des lieux, décence...), il peut être
        obligatoire de saisir la commission départementale de conciliation avant
        de faire appel au juge. Elle intervient gratuitement.{" "}
        <a
          href="https://www.service-public.fr/particuliers/vosdroits/F1216"
          target="_blank"
          rel="noreferrer"
        >
          Retrouver toutes les informations sur le site service-public.fr
        </a>
      </Text>
    ),
  },
  {
    icon: <PinIcon />,
    title: "Rencontrer un juriste de l'ADIL",
    description: (
      <Text>
        Les ADIL ont pour mission d'informer gratuitement les usagers sur leurs
        droits et leurs obligations et sur les solutions de logement qui leur
        sont adaptées. Vous pouvez trouver l'ADIL la plus proche de chez vous{" "}
        <a
          href="https://www.anil.org/lanil-et-les-adil/votre-adil/"
          target="_blank"
          rel="noreferrer"
        >
          en cliquant ici
        </a>
      </Text>
    ),
  },
  justiceAppel,
];
export const padMediateurCommunication = [
  {
    icon: <WorldIcon />,
    title: "Faire appel au Médiateur des communications électroniques ",
    description: (
      <Text>
        Vous rencontrez un litige (commercial, contractuel, technique, ...) qui
        n'a pas pu être réglé à l'amiable avec votre opérateur de téléphonie ou
        votre fournisseur d'accès internet ? Le médiateur des communications
        électroniques peut intervenir gratuitement pour tenter de résoudre votre
        litige. Retrouver la procédure à suivre sur le{" "}
        <a
          href="https://www.service-public.fr/particuliers/vosdroits/F14373"
          target="_blank"
          rel="noreferrer"
        >
          site service-public.fr
        </a>
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padCnil = [
  {
    icon: <WorldIcon />,
    title:
      "Faire appel à la CNIL (Commission Nationale de l'Informatique et des Libertés)",
    description: (
      <Text>
        La CNIL est une autorité administrative indépendante en charge de la
        régulation des données personnelles.
        <br /> Si vos démarches n'aboutissent pas ou en cas de retour
        insatisfaisant d'un organisme, vous pouvez adresser une plainte à la
        CNIL, lui demander de vérifier certains fichiers à votre place ou lui
        adresser une alerte.{" "}
        <a
          href="https://www.cnil.fr/fr/plaintes"
          target="_blank"
          rel="noreferrer"
        >
          Faire appel à la CNIL
        </a>
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padPlainte = [
  {
    icon: <WorldIcon />,
    title: "Démarches pour victimes de violences conjugales",
    description: (
      <Text>
        Les violences conjugales sont punies par la loi, qu'elles visent un
        homme ou une femme, qu'elles soient physiques, psychologiques ou
        sexuelles. Il s'agit des violences commises au sein des couples mariés,
        pacsés ou en union libre. Si vous êtes victime et que vous signalez les
        faits, vous pouvez être aidé et protégé. Vous pouvez bénéficier de
        l'aide et de la protection quelle que soit votre nationalité et quelle
        que soit la durée de votre séjour en France.{" "}
        <a
          href="https://www.service-public.fr/particuliers/vosdroits/F12544"
          target="_blank"
          rel="noreferrer"
        >
          Lien vers la démarche à suivre
        </a>
      </Text>
    ),
  },
  {
    icon: <PinIcon />,
    title:
      "Annuaire Centre d'Information sur les Droits des Femmes et des Familles (CIDFF)",
    description: (
      <Text>
        Vous souhaitez être informé·e sur vos droits, vous êtes victime de
        violences sexistes ou sexuelles... Vous pourrez être reçu dans le centre
        le plus proche de chez vous gratuitement :{" "}
        <a
          href="https://fncidff.info/trouver-mon-cidff/)"
          target="_blank"
          rel="noreferrer"
        >
          Trouver mon centre
        </a>
      </Text>
    ),
  },
  {
    icon: <CallIcon />,
    title: "Numéro d'urgence Stop aux violences faites aux femmes",
    description: (
      <Text>
        Vous êtes victime de violences, appelez le{" "}
        <a href="tel:3919" target="_blank" rel="noreferrer">
          {" "}
          39 19
        </a>{" "}
        (appel gratuit depuis un téléphone fixe ou mobile en métropole et dans
        les DOM). Ouvert 24h sur 24 et 7 jours sur 7. Appel anonyme Appel ne
        figurant pas sur les factures de téléphone
      </Text>
    ),
  },
];
export const padSncf = [
  {
    icon: <WorldIcon />,
    title: "Réclamation auprès du service client",
    description: (
      <Text>
        Vous devez faire une réclamation auprès du{" "}
        <a
          href="https://www.sncf.com/fr/service-client/reclamations"
          target="_blank"
          rel="noreferrer"
        >
          service client
        </a>
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padOperateur = [
  {
    icon: <WorldIcon />,
    title: "Réclamation auprès du service client",
    description: (
      <Text>
        Afin de régler votre problème, vous devez faire une réclamation auprès
        du service client de votre opérateur.{" "}
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
export const padTransport = [
  {
    icon: <WorldIcon />,
    title: "Réclamation auprès du service client",
    description: (
      <Text>
        Afin de régler votre problème, vous devez faire une réclamation auprès
        du service client de la société de transport.{" "}
      </Text>
    ),
  },
  justicePoints,
  justiceAppel,
];
